import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { styled as materialStyles } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import info from "../../../assets/icon.png";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "react-hook-form";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch } from "react-redux";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import FormGroup from "@mui/material/FormGroup";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import SearchIcon from "@mui/icons-material/Search";
import { FileDownload } from "@mui/icons-material";

import {
  vendorRegistration,
  hsnCategories,
  hsnValues,
  itemValues,
  getMasterItems,
  validatePAN,
  createUser,
  validateMSMENumber,
  resetvendorRegistration,
  resetLegalName,
} from "../../vendorRegistration/redux/vendorRegistrationSlice";
import { resetbankDetails } from "../../bankDetails/redux/bankDetailsSlice";
import {
  UserInfoDiv,
  VendorCardTitle,
  VendorInstructions,
  VendorListHolder,
} from "./../../vendorRegistration/components/steps/vendorReg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";
import BankReg from "./../../vendorRegistration/components/steps/bankReg";
import { useSelector } from "react-redux";
import {
  Super,
  VendorCardBlankTitle,
} from "./../../vendorRegistration/components/steps/cardTrial";
import FormHelperText from "@mui/material/FormHelperText";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
/* import ArrowRightIcon from "@mui/icons-material/ArrowRight"; */
import _without from "lodash/without";
import LocalStorage from "../../../utilities/localStorage";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import { Clear } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import BankDetailsManager from "./../../vendorRegistration/components/steps/BankDetailsManager";
import LoadingButton from "@mui/lab/LoadingButton";
import { message } from "antd";
import { companyListForOfficer } from "../../adminTable/redux/sendLinkSlice";
import { CustomDocumentLink } from "../../../common/sharedComponents/styles/card.style";
import VRF_vishakha from "../../../assets/F-PUR-03-VRF-Vishakha.DOCX";
import VRF_vishakha_undertaking from "../../../assets/INTEGRITY-UNDERTAKING-Vishakha.doc";
import { GlobalAutocomplete } from "../../../common/sharedComponents/AutoComplate";
import { useLazyGetCategorySAPwiseQuery } from "../../../utilities/redux-api/vendor_category/api";
const steps = [
  "Vendor Basic Information",
  "Vendor Details",
  "Business Details",
  "Bank Details",
];
const Input = materialStyles("input")({
  display: "none",
});
export default function StepMain() {
  const {
    legal_name,
    createdUser,
    vendor_id,
    categories,
    subcategories,
    itemcategories,
    items: Items,
    vendor_details,
    msmeLoading,
  } = useSelector((state) => state.vendorRegistration);
  const { companyList } = useSelector((state) => state.sendInvitationLink);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [domestic, setDomestic] = useState(true);
  const [annualCr, setAnnualCr] = useState("₹0.00 CR");
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    company_name: "",
    contact_person_email: "",
    user_password: "",
    buyer_company_id: "",
  });
  const [pan, setPan] = useState(null);
  const [legalName, setLegalName] = useState("");
  const [checkedPan, setCheckedPan] = useState(false);
  const [checkedMSME, setCheckedMSME] = useState(false);
  const [panDoc, setPanDoc] = useState("");
  const [dealer, setDealer] = useState("");
  const [dealerIntegrity, setDealerIntegrity] = useState("");
  const [tin, setTin] = useState("");
  const [iso, setIso] = useState("");
  const [checkedType, setCheckedType] = useState("");
  const [mSME, setMSME] = useState("");
  // const [checkedItemType, setCheckedItemType] = useState("");
  const [subCategory, setSubCategory] = useState("");

  const [userinfo, setUserInfo] = useState({
    codes: [],
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingsub, setIsLoadingsub] = useState(false);
  const [search, setSearch] = useState("");
  const [searchsub, setSearchsub] = useState("");
  const [catdisplay, setCatdisplay] = useState("none");
  const [subcatdisplay, setSubcatdisplay] = useState("none");

  const [itemcodes, setItemcodes] = useState("");
  const [isLoadingitem, setIsLoadingitem] = useState(false);
  const [searchitem, setSearchitem] = useState("");
  const [itemcatdisplay, setItemcatdisplay] = useState("none");

  // const [masterItemcodes, setMasterItemcodes] = useState("");
  const [isLoadingMasteritem, setIsLoadingMasteritem] = useState(false);
  const [mastercatdisplay, setMastercatdisplay] = useState("none");
  const [searchMasteritem, setSearchMasteritem] = useState("");
  // const [itemcatdisplay, setItemcatdisplay] = useState("none");

  const [msmeDoc, setmsmeDoc] = useState("");

  const [vendorData, setVendorData] = useState({
    company_constitution: "",
    company_nature: "",
    affirmative_action_category: "",
    registration_type: "",
    tax_identification_number: "",
    annual_turnover: "",
    msme_register: "",
    msme_registration_number: "",
    expiry_date: "",
  });
  const [trigger, { data }] = useLazyGetCategorySAPwiseQuery();
  const onCompanySelect = (data) => {
    trigger(data?.key);
    clearCategoryDropdown("category", null);
    setUserData((prev) => ({
      ...prev,
      buyer_company_id: data?.key,
    }));
  };
  const dispatch = useDispatch();
  const onSubmit = (payload) => {
    setLoading(true);
    dispatch(vendorRegistration(payload)).then((response) => {
      const { success } = response?.payload;
      if (success) {
        setLoading(false);
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
      } else {
        setLoading(false);
      }
    });
  };

  const getCategories = (payload) => {
    dispatch(hsnCategories(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoading(false);
      }
    });
  };

  const getItems = (payload) => {
    dispatch(getMasterItems(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingMasteritem(false);
      }
    });
  };

  const getHSNCodes = (payload) => {
    dispatch(hsnValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingsub(false);
      }
    });
  };

  const getItemsCodes = (payload) => {
    dispatch(itemValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingitem(false);
      }
    });
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleVendorInformationChange = (e) => {
    e.persist();
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setValue(e.target.name, e.target.value);
  };

  const handlePanChange = (value) => {
    setValue("permanent_account_number", value);
    setPan(value);
  };

  const validatePan = () => {
    let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);

    if (!regex.test(pan)) {
      return message.info("please enter valid PAN");
    }
    dispatch(validatePAN({ pan: pan }));
  };

  const validateMsme = () => {
    if (!msmenum) {
      return message.info("Please enter MSME Registration Number");
    }
    dispatch(
      validateMSMENumber({
        msme: msmenum,
        company_constitution: vendorData?.company_constitution,
        legal_name: legalName,
        user_id:
          user?.roles?.[0] === "officer"
            ? createdUser?.id
            : user?.user_id || undefined,
      }),
    ).then((response) => {
      const { success, data } = response.payload;
      if (
        success &&
        data?.[0]?.status === "completed" &&
        data?.[0]?.result?.source_output?.status === "id_found"
      ) {
        setCheckedMSME(true);
      } else {
        setCheckedMSME(false);
      }
    });
  };

  useEffect(() => {
    setLegalName(legal_name);
  }, [legal_name]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    unregister,
    control,
    setValue: clearCategoryDropdown,
    reset: resetForm1,
  } = useForm();
  useEffect(() => {
    dispatch(companyListForOfficer(""));
    dispatch(resetLegalName());
    dispatch(resetvendorRegistration());
    dispatch(resetbankDetails());
  }, [dispatch]);
  const {
    register: registerdata,
    formState: { errors: errorsdata },
    handleSubmit: handleSubmitData,
    setValue,
    reset: resetForm2,
  } = useForm();

  var user = LocalStorage.getItem("tata_login_user");
  var client = LocalStorage.getItem("client");
  const isTenant2 = client?.id === 2;
  const isLocked = vendor_details?.is_pending === true;
  const isApprovedStatus =
    vendor_details?.is_fully_approved === true ||
    vendor_details?.is_approved === true;
  const isNameLocked = isApprovedStatus || isLocked;
  const isLocationLocked = isApprovedStatus || isLocked;

  const handleNext = (data) => {
    if (isTenant2 && activeStep === 1) {
      if (!userinfo.codes || userinfo.codes.length === 0) {
        return message.error("HSN/SAC codes are required for registration.");
      }
    }
    if (activeStep === 1 && domestic && mSME === "Applicable" && !checkedMSME) {
      return message.error(
        "Please validate your MSME registration number before proceeding.",
      );
    }
    var formData = new FormData();
    if (user.roles[0] === "officer") {
      data = { ...data, user_id: createdUser.id };
    }
    for (let i = 0; i < newDocs.length; i++) {
      formData.append("supporting_document_image", anyDocs[i]);
    }

    formData.append("data", JSON.stringify(data));
    formData.append("pan_image", panDoc);
    formData.append("dealer_authorization_image", dealer);
    formData.append("dealer_integrity_image", dealerIntegrity);
    formData.append("msme_certificate_image", msmeDoc);
    formData.append("tin_certificate_image", tin);
    formData.append("iso_or_rsdo_or_any_image", iso);
    formData.append("codes", JSON.stringify(userinfo.codes));
    formData.append("pan_declaration", checkedPan);

    onSubmit(formData);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setCheckedPan(false);
  };
  const handleReset = () => {
    setActiveStep(0);
    setSkipped(new Set());
    setDomestic(true);
    setAnnualCr("₹0.00 CR");
    setUserData({
      first_name: "",
      last_name: "",
      company_name: "",
      contact_person_email: "",
      user_password: "",
      buyer_company_id: "",
    });
    setPan(null);
    setLegalName("");
    setCheckedPan(false);
    setPanDoc("");
    setDealer("");
    setDealerIntegrity("");
    setTin("");
    setIso("");
    setCheckedType("");
    setMSME("");
    setSubCategory("");
    setUserInfo({
      codes: [],
    });
    setSearch("");
    setSearchsub("");
    setCatdisplay("none");
    setSubcatdisplay("none");
    setItemcodes("");
    setSearchitem("");
    setItemcatdisplay("none");
    setIsLoadingMasteritem(false);
    setMastercatdisplay("none");
    setSearchMasteritem("");
    setmsmeDoc("");
    setVendorData({
      company_constitution: "",
      company_nature: "",
      affirmative_action_category: "",
      registration_type: "",
      tax_identification_number: "",
      annual_turnover: "",
      msme_register: "",
      msme_registration_number: "",
      expiry_date: "",
    });
    setPersonName([]);
    setMsmenum("");
    setNewDocs([1]);
    setAnyDocs([]);
    resetForm1();
    resetForm2();
    dispatch(resetvendorRegistration());
    dispatch(resetbankDetails());
  };

  const handleChange = (event) => {
    if (event.target.checked) {
      setCheckedPan(true);
    } else {
      setCheckedPan(false);
    }
  };
  const [loading, setLoading] = useState(false);

  const convertToMillions = (e) => {
    const num = e.target.value;
    if (num === undefined) return "";
    const millions = num / 10;

    const ready =
      millions.toLocaleString("en-IN", { style: "currency", currency: "INR" }) +
      " CR";
    setAnnualCr(ready);
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setVendorData({ ...vendorData, [name]: value });
    if (name === "annual_turnover") {
      convertToMillions(e);
    }

    if (name === "msme_register") {
      setVendorData({
        ...vendorData,
        msme_registration_number: "",
        expiry_date: "",
        msme_register: value,
      });
      setCheckedMSME(false);
    }
    if (name === "company_constitution") {
      setCheckedMSME(false);
    }
  };

  const handleadditionalChange = (e, type) => {
    setCheckedType(type);
    type === "3" ? getItems("") : getCategories(type === "2" ? "HSN" : "SAC");
    type === "3" ? setIsLoadingMasteritem(true) : setIsLoading(true);
    if (Number(type) === "3") {
      setMastercatdisplay("block");
    } else {
      setCatdisplay("block");
    }
    type === "3" ? setSearchMasteritem("") : setSearch("");

    setItemcatdisplay("none");
    setSubcatdisplay("none");
  };

  // const handleadditionalItem = (e) => {
  //   setIsLoading(true);
  //   setSearchMasteritem("");
  //   setMasterItemcodes("block");
  // };
  const initialSelected = [];
  const [personName, setPersonName] = useState(initialSelected);

  // const [registrationtype, setRegistrationtype] = useState("");
  const [msmenum, setMsmenum] = useState("");

  const handlecategoryChange = (e, type) => {
    setSubCategory(type);
    getHSNCodes(type);
    setIsLoadingsub(true);
    setSearchsub("");
    setSubcatdisplay("block");
    setItemcatdisplay("none");
  };

  const handlesubcategoryChange = (e, type) => {
    setItemcodes(type);
    getItemsCodes(type);
    setIsLoadingitem(true);
    setSearchitem("");
    setItemcatdisplay("block");
  };

  const handleDelete = (chipToDelete) => () => {
    let codes = userinfo.codes;

    let filtered = codes.filter((codes) =>
      codes.toLowerCase().includes(chipToDelete.toLowerCase()),
    );
    const array1 = codes.filter((val) => !filtered.includes(val));
    setUserInfo({
      codes: array1,
    });
    setPersonName((current) => _without(current, chipToDelete));
    // setUserInfo({})
  };

  const handleCheckChange = (e, type) => {
    const { checked } = e.target;
    const { codes } = userinfo;
    if (checked) {
      setUserInfo({
        codes: [...codes, type],
      });
      setPersonName([...personName, type]);
    }
  };

  // const handleregistrationChange = (e) => {
  //   setRegistrationtype(e.target.value);
  // };

  const toggleDomestic = () => {
    setDomestic(!domestic);
  };

  useEffect(() => {
    if (domestic === false) {
      unregister("pan");
      unregister("registration_type");
      unregister("msme_register");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domestic]);

  const createUserFn = () => {
    setLoading(true);
    dispatch(
      createUser({
        first_name: userData.first_name,
        last_name: userData.last_name,
        company_name: userData.company_name,
        contact_person_email: userData.contact_person_email,
        company_email: userData.contact_person_email,
        company_id: userData.buyer_company_id,
        password: userData.user_password,
        vcm_id: userData.vcm_id,
        pan: pan,
        is_domestic: domestic,
        legal_name: legalName,
        creater_id: user?.user_id,
      }),
    ).then((response) => {
      const { success } = response?.payload;
      if (success) {
        setLoading(false);
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
      } else {
        setLoading(false);
      }
    });
  };
  const [newDocs, setNewDocs] = useState([1]);
  const [anyDocs, setAnyDocs] = useState([]);
  const handleclearDoc = (e, index) => {
    let newDocValues = { ...anyDocs, [index]: "" };

    setAnyDocs(newDocValues);
  };
  const handleRemove = (e, i) => {
    let uploadeddocs = [...newDocs];
    uploadeddocs.splice(i, 1);
    setNewDocs(uploadeddocs);
  };
  const handleOnClick = () => {
    let docsCopy = [...newDocs];

    docsCopy.push({
      any_docs: "",
    });

    setNewDocs(docsCopy);
  };
  const handlechangeDoc = (e, index) => {
    let newDocValues = { ...anyDocs, [index]: e.target.files[0] };

    setAnyDocs(newDocValues);
  };

  const code_filtered = !search
    ? categories
    : categories.filter((categories) =>
        categories.categortDescription
          .toLowerCase()
          .includes(search.toLowerCase()),
      );

  const sub_filtered = !searchsub
    ? subcategories
    : subcategories.filter((subcategories) =>
        subcategories.subCategory
          .toLowerCase()
          .includes(searchsub.toLowerCase()),
      );

  const item_filtered = !searchitem
    ? itemcategories
    : itemcategories.filter((itemcategories) =>
        itemcategories.item.toLowerCase().includes(searchitem.toLowerCase()),
      );
  const master_item_filtered = !searchMasteritem
    ? Items
    : Items.filter((items) =>
        items.MaterialCode.toLowerCase().includes(
          searchMasteritem.toLowerCase(),
        ),
      );

  const radioStyles = {
    selectRadio: {
      border: "1px solid #D9D8FF",
      padding: "0px 7px 0px 7px",
      background: "#D9D8FF",
      borderRadius: "4px",
      marginLeft: "-6px",
    },
  };

  const radioStyles1 = {
    selectRadio: {
      border: "1px solid #D9D8FF",
      padding: "0px 7px 0px 7px",
      background: "#D9D8FF",
      borderRadius: "4px",
      marginLeft: "-6px",
      marginRight: "15px",
    },
  };
  var user = LocalStorage.getItem("tata_login_user");
  var client = LocalStorage.getItem("client");
  // var domain_name = LocalStorage.getItem("client")?.domain_url;

  // const is_domestic = user.is_domestic;

  const vendor_information = (
    <CardContent>
      <Container fixed>
        <Grid>
          <VendorCardTitle>Vendor Information</VendorCardTitle>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                defaultChecked={domestic}
                onChange={toggleDomestic}
                name="domestic"
              />
            }
            label={<CheckBoxLabel>Domestic</CheckBoxLabel>}
          />

          <UserInfoDiv>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  First Name<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  {...registerdata("first_name", {
                    required: "Please First Vendor Name",
                  })}
                  error={Boolean(errorsdata?.first_name)}
                  helperText={errorsdata.first_name?.message}
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  style={{
                    width: "100%",
                    paddingTop: "3px",
                    borderBottom: "1px solid lightgray",
                  }}
                  id="first_name"
                  value={userData.first_name}
                  placeholder="Enter first name"
                  onChange={handleVendorInformationChange}
                  name="first_name"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  Last Name<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  {...registerdata("last_name", {
                    required: "Please Add Last Name",
                  })}
                  error={Boolean(errorsdata?.last_name)}
                  helperText={errorsdata.last_name?.message}
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  style={{
                    width: "100%",
                    paddingTop: "3px",
                    borderBottom: "1px solid lightgray",
                  }}
                  name="last_name"
                  value={userData.last_name}
                  placeholder="Enter last name"
                  onChange={handleVendorInformationChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  Company Name<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  {...registerdata("company_name", {
                    required: "Please Add Company Name",
                  })}
                  error={Boolean(errorsdata?.company_name)}
                  helperText={errorsdata.company_name?.message}
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  style={{
                    width: "100%",
                    paddingTop: "3px",
                    borderBottom: "1px solid lightgray",
                  }}
                  name="company_name"
                  value={userData.company_name}
                  placeholder="Enter company name"
                  onChange={handleVendorInformationChange}
                />
                {/* <FormHelperText error>{errors.company_name?.message}</FormHelperText> */}
              </Grid>
            </Grid>
            <br />
            <Grid container spacing={3}>
              <input
                type="text"
                name="email"
                autoComplete="username"
                style={{ display: "none" }}
              />
              <input
                type="text"
                name="password"
                autoComplete="password"
                style={{ display: "none" }}
              />
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  Email<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  {...registerdata("contact_person_email", {
                    pattern: {
                      value:
                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "Invalid email address",
                    },
                    required: "Please enter email",
                  })}
                  error={Boolean(errorsdata?.contact_person_email)}
                  helperText={errorsdata.contact_person_email?.message}
                  autoComplete="off"
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  inputProps={{
                    autoComplete: "off",
                    name: "contact_person_email",
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  style={{
                    width: "100%",
                    paddingTop: "3px",
                    borderBottom: "1px solid lightgray",
                  }}
                  name="contact_person_email"
                  value={userData.contact_person_email}
                  placeholder="Enter vendor email"
                  onChange={handleVendorInformationChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  Password<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  {...registerdata("user_password", {
                    required: "Please Add Password",
                  })}
                  error={Boolean(errorsdata?.user_password)}
                  helperText={errorsdata.user_password?.message}
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  style={{
                    width: "100%",
                    paddingTop: "3px",
                    borderBottom: "1px solid lightgray",
                  }}
                  name="user_password"
                  value={userData.user_password}
                  type="password"
                  placeholder="Enter password"
                  onChange={handleVendorInformationChange}
                />
                <FormHelperText error>
                  {errors.user_password?.message}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <GlobalAutocomplete
                  label={"Select Company"}
                  name={"buyer_company_id"}
                  placeholder={"Select a Company"}
                  options={companyList.map((company, index) => {
                    return {
                      key: company.id,
                      value: company?.company_name,
                    };
                  })}
                  control={control}
                  rules={{ required: `Company is required` }}
                  onSelect={onCompanySelect}
                />
                {/* <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.buyer_company_id)}
                >
                  <VendorCardLabel>
                    Select Company<Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    defaultValue=""
                    IconComponent={() => (
                      <ExpandMore style={{ color: "#A5A5BA" }} />
                    )}
                    labelId="demo-simple-select-standard-label"
                    id="buyer_company_id"
                    label="company id"
                    {...register("buyer_company_id", {
                      required: "Please Select Comapny",
                    })}
                    value={userData.buyer_company_id}
                    name="buyer_company_id"
                    onChange={(e) =>
                      setUserData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Buyer Company
                      </span>
                    </MenuItem>
                    {companyList.map((company, index) => {
                      return (
                        <MenuItem key={index} value={company.id}>
                          <SelectSpan>{company.company_name}</SelectSpan>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl> */}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <GlobalAutocomplete
                  label={"Select Vendor Category"}
                  name={"category"}
                  placeholder={"Select a Vendor Category"}
                  options={
                    data?.data?.map((el, index) => {
                      return {
                        key: el.id,
                        value: `${el.type} (${el?.type_code})`,
                      };
                    }) ?? []
                  }
                  control={control}
                  rules={{ required: `Vendor Category is required` }}
                  onSelect={(data) => {
                    setUserData((prev) => ({
                      ...prev,
                      vcm_id: data?.key,
                    }));
                  }}
                />
              </Grid>
            </Grid>
            <br />
            {domestic ? (
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>
                    PAN<Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    {...registerdata("permanent_account_number", {
                      required: "Please enter permanent account number",
                    })}
                    error={Boolean(errorsdata?.permanent_account_number)}
                    helperText={errorsdata.permanent_account_number?.message}
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      borderBottom: "1px solid lightgray",
                    }}
                    value={pan || ""}
                    name="permanent_account_number"
                    placeholder="Enter vendor PAN"
                    onChange={(e) => handlePanChange(e.target.value)}
                  />
                  {/* <FormHelperText>
                    {errors.permanent_account_number?.message}
                  </FormHelperText> */}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>Legal Name</VendorCardLabel>
                  <VendorDisabledFields
                    style={{
                      borderBottom: "1px solid lightgray",
                      width: "100%",
                      padding: "5px 0",
                      color: legal_name ? "#212134" : "#A5A5BA",
                      minHeight: "24px",
                    }}
                  >
                    {legalName ||
                      "Legal name will appear here after validation"}
                  </VendorDisabledFields>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Button
                    variant="contained"
                    sx={{ width: "150px", marginTop: "10px" }}
                    onClick={(e) => validatePan(e)}
                  >
                    Validate PAN
                  </Button>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </UserInfoDiv>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1, display: "none" }}
            >
              Back
            </Button>

            <Box sx={{ flex: "1 1 auto" }} />
            <LoadingButton
              sx={{
                textTransform: "none",
                background: "var(--button-color)",
                width: "200px",
                height: "40px",
              }}
              color="success"
              variant="contained"
              type="submit"
              disabled={loading || (domestic && !legalName)}
              loading={loading}
              loadingPosition="start"
            >
              {activeStep === steps.length - 1
                ? client?.id === 2
                  ? "Save & Next"
                  : "Finish"
                : "Save & Next"}
            </LoadingButton>
          </Box>
        </Grid>
      </Container>
    </CardContent>
  );

  const card = (
    <CardContent>
      {/* {is_domestic} */}
      <Typography gutterBottom variant="h6" component="div">
        <VendorInstructions>
          <img src={info} alt="info" /> Instructions
        </VendorInstructions>
      </Typography>
      <br />

      <VendorListHolder>
        <li>
          Enter statutory information which includes company nature,
          constitution and GST registration type.
        </li>
        <li>
          Legal name is auto-populated as per the information on the PAN
          database. It is not editable for vendors.
        </li>
        <li>
          Enter all the mandatory fields before proceeding to enter location
          information.
        </li>
        <li>
          Submit the bank details to complete the vendor registration process.
        </li>
      </VendorListHolder>
    </CardContent>
  );

  const statutory_information = (
    <CardContent>
      <Container fixed>
        <Grid>
          <VendorCardTitle>Statutory information</VendorCardTitle>
          <UserInfoDiv>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Company name</VendorCardLabel>
                <VendorDisabledFields>
                  {userData.company_name}
                </VendorDisabledFields>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Company email</VendorCardLabel>

                <VendorDisabledFields>
                  {userData.contact_person_email}
                </VendorDisabledFields>
              </Grid>
              <Grid item xs={12} md={4}>
                <VendorCardLabel>
                  Permanent account number (PAN)
                </VendorCardLabel>

                <VendorDisabledFields>
                  {(typeof pan !== undefined || pan !== "") && legal_name
                    ? `${pan}`
                    : `International`}
                </VendorDisabledFields>
              </Grid>
            </Grid>
          </UserInfoDiv>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>
              Legal name <Super>*</Super>
            </VendorCardLabel>

            <VendorDisabledFields
              style={{
                borderBottom: "1px solid lightgray",
                width: "100%",
                padding: " 0 0 5px 0",
                paddingTop: "5px",
              }}
            >
              {legal_name ? `${legal_name}` : `Not Applicable`}
            </VendorDisabledFields>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_constitution)}
            >
              <VendorCardLabel>
                Company constitution <Super>*</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_constitution"
                label="Company consistution (As per GST certificate)"
                name="company_constitution"
                {...register("company_constitution", {
                  required: "Please select constitution",
                })}
                value={vendorData.company_constitution || ""}
                onChange={(e) => onChange(e)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select constitution
                  </span>
                </MenuItem>

                <MenuItem value="Public Limited Company">
                  <SelectSpan>Public Limited Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Association of Persons (AOP)">
                  <SelectSpan>Association of Persons (AOP)</SelectSpan>
                </MenuItem>
                <MenuItem value="Partnership Firm">
                  <SelectSpan>Partnership Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Individual/One person Company">
                  <SelectSpan>Individual/One person Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Joint Venture (JV)">
                  <SelectSpan>Joint Venture (JV)</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited Liability Partnership (LLP)">
                  <SelectSpan>Limited Liability Partnership (LLP)</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited Company/Listed company">
                  <SelectSpan>Limited Company/Listed company</SelectSpan>
                </MenuItem>
                <MenuItem value="Non banking finance company/ Banking company">
                  <SelectSpan>
                    Non banking finance company/ Banking company
                  </SelectSpan>
                </MenuItem>
                <MenuItem value="Proprietary Firm">
                  <SelectSpan>Proprietary Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Private Limited">
                  <SelectSpan>Private Limited</SelectSpan>
                </MenuItem>
                <MenuItem value="co-operativesociety">
                  <SelectSpan>Co-operative society</SelectSpan>
                </MenuItem>
                <MenuItem value="Foreign Company">
                  <SelectSpan>Foreign Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Hindu Undivided Family">
                  <SelectSpan>Hindu Undivided Family</SelectSpan>
                </MenuItem>
                <MenuItem value="Government Company">
                  <SelectSpan>Government Company</SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>
                {errors.company_constitution?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_nature)}
            >
              <VendorCardLabel>
                Company nature<Super> *</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_nature"
                label="company_nature"
                name="company_nature"
                {...register("company_nature", {
                  required: "Please select company nature",
                })}
                value={vendorData.company_nature || ""}
                onChange={(e) => onChange(e)}
                error={Boolean(errors?.company_nature)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select company nature
                  </span>
                </MenuItem>

                <MenuItem value="dta">
                  <SelectSpan>Domestic Tariff Area (DTA)</SelectSpan>
                </MenuItem>
                <MenuItem value="domestic">
                  <SelectSpan> Indian Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Foreign Company">
                  <SelectSpan>Foreign Company (Outside India)</SelectSpan>
                </MenuItem>
                <MenuItem value="sez">
                  <SelectSpan>Special Economic Zone (SEZ)</SelectSpan>
                </MenuItem>
                <MenuItem value="stpi">
                  <SelectSpan>
                    Software Technology Parks of India (STPI)
                  </SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>{errors.company_nature?.message}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.affirmative_action_category)}
            >
              <VendorCardLabel>Affirmative action category</VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="affirmative_action_category"
                label="Affirmative action category"
                name="affirmative_action_category"
                {...register("affirmative_action_category", {
                  required: false,
                })}
                value={vendorData.affirmative_action_category || ""}
                onChange={(e) => onChange(e)}
                error={Boolean(errors?.affirmative_action_category)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select category
                  </span>
                </MenuItem>
                <MenuItem value="open">
                  <SelectSpan>OPEN</SelectSpan>
                </MenuItem>
                <MenuItem value="obc">
                  <SelectSpan>OBC</SelectSpan>
                </MenuItem>
                <MenuItem value="sc">
                  <SelectSpan>SC/ST</SelectSpan>
                </MenuItem>
                <MenuItem value="other">
                  <SelectSpan>OTHERS</SelectSpan>
                </MenuItem>
                <MenuItem value="dnd">
                  <SelectSpan>Don't wish to declare</SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>
                {errors.affirmative_action_category?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
          {domestic && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.registration_type)}
              >
                <VendorCardLabel>
                  Registration type (GST) <Super>*</Super>
                </VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  defaultValue=""
                  displayEmpty={true}
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="registration_type"
                  label="Registration_type"
                  name="registration_type"
                  {...register("registration_type", {
                    required: "Please select registration type",
                  })}
                  error={Boolean(errors?.registration_type)}
                  value={
                    vendorData.registration_type
                      ? vendorData.registration_type
                      : vendorData.registration_type || ""
                  }
                  onChange={(e) => onChange(e)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select registration type
                    </span>
                  </MenuItem>
                  <MenuItem value="regular">
                    <SelectSpan>Regular</SelectSpan>
                  </MenuItem>
                  <MenuItem value="composition">
                    <SelectSpan>Composition</SelectSpan>
                  </MenuItem>
                  <MenuItem value="unregistered">
                    <SelectSpan>Not Applicable</SelectSpan>
                  </MenuItem>
                </Select>
                <FormHelperText>
                  {errors.registration_type?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Tax Identification number (TIN)</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              placeholder="Do not enter GSTIN here"
              size="small"
              variant="standard"
              style={{ width: "100%", paddingTop: "3px" }}
              name="tax_identification_number"
              {...register("tax_identification_number", { required: false })}
              value={vendorData.tax_identification_number || ""}
              onChange={(e) => onChange(e)}
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in Million)</VendorCardLabel>
            <TextField
              type="number"
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              style={{
                width: "100%",
                paddingTop: "3px",
                borderBottom: "1px solid lightgray",
              }}
              name="annual_turnover"
              placeholder="Enter annual turnover"
              {...register("annual_turnover", {
                pattern: {
                  value: /^-?\d*(\.\d{1,2})?$/,
                  message: "Invalid number format",
                },
              })}
              value={vendorData.annual_turnover || ""}
              error={Boolean(errors?.annual_turnover)}
              helperText={errors.annual_turnover?.message}
              onChange={(e) => onChange(e)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in Crore)</VendorCardLabel>
            <VendorDisabledFields>{annualCr}</VendorDisabledFields>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );

  const msme_information = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>MSME information</VendorCardTitle>
        <VRSubTitle>For tax purposes</VRSubTitle>
        <Grid container spacing={1}>
          {domestic && (
            <Grid item xs={12} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.msme_register)}
              >
                <VendorCardLabel>
                  Are you MSME registered? <Super>*</Super>
                </VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  defaultValue=""
                  displayEmpty={true}
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  label="Are you MSME registered?"
                  name="msme_register"
                  {...register("msme_register", {
                    required: "Please select MSME category",
                  })}
                  onChange={(e) => setMSME(e.target.value)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select value
                    </span>
                  </MenuItem>
                  <MenuItem value="Applicable">
                    <SelectSpan>Applicable</SelectSpan>
                  </MenuItem>
                  <MenuItem value="others">
                    <SelectSpan>Not Applicable</SelectSpan>
                  </MenuItem>
                </Select>
                <FormHelperText>{errors.msme_register?.message}</FormHelperText>
              </FormControl>
            </Grid>
          )}

          {mSME !== "others" && mSME !== "" ? (
            <>
              <Grid item xs={12} md={4}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    MSME registration number <Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      borderBottom: "1px solid lightgray",
                    }}
                    name="msme_registration_number"
                    placeholder="Enter MSME registration number"
                    {...register("msme_registration_number", {
                      required: "Please enter MSME number",
                    })}
                    error={Boolean(errors?.msme_registration_number)}
                    helperText={errors.msme_registration_number?.message}
                    value={msmenum || ""}
                    onChange={(e) => {
                      setMsmenum(e.target.value);
                      setCheckedMSME(false);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <LoadingButton
                  variant="contained"
                  loading={msmeLoading}
                  startIcon={checkedMSME ? <CheckCircleIcon /> : null}
                  sx={{
                    width: "160px",
                    marginTop: "10px",
                    backgroundColor: checkedMSME ? "#4caf50" : undefined,
                    "&:hover": checkedMSME
                      ? { backgroundColor: "#388e3c" }
                      : undefined,
                    pointerEvents: checkedMSME ? "none" : "auto",
                  }}
                  onClick={validateMsme}
                  disabled={!msmenum}
                >
                  {checkedMSME ? "Validated" : "Validate MSME"}
                </LoadingButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={6}>
                    <span
                      variant="outlined"
                      component="span"
                      style={{ width: "50%" }}
                    >
                      <DocumentLabels>
                        Upload MSME copy<Super>*</Super>
                      </DocumentLabels>
                    </span>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl
                      variant="standard"
                      style={{ width: "100%" }}
                      error={Boolean(errors?.msme)}
                    >
                      {msmeDoc !== "" ? (
                        <>
                          <span
                            style={{
                              color: "#4945FF",
                              fontSize: "13px",
                              fontFamily: "var(--font-family-reg)",
                            }}
                          >
                            <Chip
                              style={{
                                width: "150px",
                                color: "#4945FF",
                                margin: "5px",
                                borderRadius: "5px",
                                border: "1px solid #D9D8FF",
                                background: "#F0F0FF",
                              }}
                              label={msmeDoc.name}
                              value={msmeDoc.name}
                              name="chips"
                            />
                            <HighlightOffIcon
                              sx={{ color: "#4945FF", paddingBottom: "2px" }}
                              fontSize="medium"
                              onClick={(e) => setmsmeDoc("")}
                            />
                          </span>
                        </>
                      ) : (
                        <label htmlFor="msme">
                          <Input
                            {...register("msme", {
                              required: "Please upload MSME copy",
                            })}
                            accept="*"
                            id="msme"
                            onChange={(e) => setmsmeDoc(e.target.files[0])}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {msmeDoc === "" ? (
                        <FormHelperText style={{ color: "red" }}>{errors.msme?.message}</FormHelperText>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
      </Container>
    </CardContent>
  );

  const documents = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle style={{ marginBottom: "3px" }}>
          Documents
        </VendorCardTitle>
        <VRSubTitle>
          <span>
            <img src={info} alt="icon" />
          </span>
          {"\u00A0"}
          {"\u00A0"}
          TDS may be deducted at higher rates in case of incorrect or missing
          PAN information as per IT rules
        </VRSubTitle>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {domestic && (
            <>
              <Grid item xs={6}>
                <span
                  variant="outlined"
                  component="span"
                  style={{ width: "50%" }}
                >
                  <DocumentLabels>
                    Upload PAN copy {domestic ? <Super>*</Super> : ""}
                  </DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.pan)}
                >
                  {panDoc !== "" ? (
                    <>
                      <span
                        style={{
                          color: "#4945FF",
                          fontSize: "13px",
                          fontFamily: "var(--font-family-reg)",
                        }}
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={panDoc.name}
                          value={panDoc.name}
                          name="chips"
                        />
                        <HighlightOffIcon
                          sx={{ color: "#4945FF", paddingBottom: "2px" }}
                          fontSize="medium"
                          onClick={(e) => setPanDoc("")}
                        />
                      </span>
                    </>
                  ) : (
                    <label htmlFor="pan">
                      <Input
                        {...register("pan", {
                          required: domestic ? "Please upload PAN copy" : false,
                        })}
                        accept="*"
                        id="pan"
                        onChange={(e) => setPanDoc(e.target.files[0])}
                        type="file"
                      />
                      <StyledOutlineButton variant="outlined" component="span">
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                  {panDoc === "" ? (
                    <FormHelperText>{errors.pan?.message}</FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>
        <br />

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                {client?.id === 3 ? "VAD" : "Vendor information form"}
                {client?.id === 1 || client?.id === 5 ? "" : <Super>*</Super>}
              </DocumentLabels>
              {client?.id === 2 ? (
                <CustomDocumentLink
                  style={{ fontSize: "0.8rem" }}
                  href={VRF_vishakha}
                >
                  <FileDownload fontSize="small" color="primary" />
                  {"\u00A0"} Download Form
                </CustomDocumentLink>
              ) : (
                ""
              )}
            </span>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.dealerName)}
            >
              {dealer !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={dealer.name}
                      value={dealer.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDealer("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealer">
                  <Input
                    {...register("dealerName", {
                      required:
                        client?.id === 1 || client?.id === 5
                          ? false
                          : "Please upload vendor form copy",
                    })}
                    accept="*"
                    id="dealer"
                    name="dealer"
                    onChange={(e) => setDealer(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{dealer.name}</span>
                </label>
              )}
              {dealer === "" ? (
                <FormHelperText>{errors.dealerName?.message}</FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
        </Grid>

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                Integrity Undertaking
                <Super>*</Super>
              </DocumentLabels>
              {client?.id === 2 ? (
                <CustomDocumentLink
                  style={{ fontSize: "0.8rem" }}
                  href={VRF_vishakha_undertaking}
                >
                  <FileDownload fontSize="small" color="primary" />
                  {"\u00A0"} Download Integrity Undertaking
                </CustomDocumentLink>
              ) : (
                ""
              )}
            </span>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.dealerIntegrityName)}
            >
              {dealerIntegrity !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={dealerIntegrity.name}
                      value={dealerIntegrity.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDealerIntegrity("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealerIntegrity">
                  <Input
                    {...register("dealerIntegrityName", {
                      required:
                        client?.id === 1 || client?.id === 5
                          ? false
                          : "Please upload vendor integrity undertaking",
                    })}
                    accept="*"
                    id="dealerIntegrity"
                    name="dealerIntegrity"
                    onChange={(e) => setDealerIntegrity(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{dealerIntegrity.name}</span>
                </label>
              )}
              {dealerIntegrity === "" ? (
                <FormHelperText>
                  {errors.dealerIntegrityName?.message}
                </FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
        </Grid>

        <br />
        {client?.id === 2 ? (
          ""
        ) : (
          <>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span
                  variant="outlined"
                  component="span"
                  style={{ width: "50%" }}
                >
                  <DocumentLabels> Upload TIN certificate</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {tin !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={tin.name}
                        value={tin.name}
                        name="chips"
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setTin("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="tin_doc">
                    <Input
                      accept="*"
                      id="tin_doc"
                      name="tin_doc"
                      onChange={(e) => setTin(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                    <span>{tin.name}</span>
                  </label>
                )}
              </Grid>
            </Grid>
            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <span
                  variant="outlined"
                  component="span"
                  style={{ width: "50%" }}
                >
                  <DocumentLabels>
                    Upload ISO, RSDO and any additional certificate
                  </DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {iso !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={iso.name}
                        value={iso.name}
                        name="chips"
                      />
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setIso("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="iso_doc">
                    <Input
                      accept="*"
                      id="iso_doc"
                      name="iso_doc"
                      onChange={(e) => setIso(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                    <span>{iso.name}</span>
                  </label>
                )}
              </Grid>
            </Grid>
          </>
        )}

        {newDocs.map((item, index) => (
          <>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              key={index}
            >
              <>
                <Grid item xs={6}>
                  <span
                    variant="outlined"
                    component="span"
                    style={{ width: "50%" }}
                  >
                    <DocumentLabels style={{ marginTop: "10px" }}>
                      Upload Any Documents
                    </DocumentLabels>
                  </span>
                </Grid>
                {anyDocs[index] !== "" && anyDocs[index] !== undefined ? (
                  <>
                    <Grid item xs={6}>
                      <FormControl variant="standard" style={{ width: "100%" }}>
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={anyDocs[index].name}
                            value={anyDocs[index].name}
                            name="chips"
                          />
                          <HighlightOffIcon
                            sx={{ color: "#4945FF", paddingBottom: "2px" }}
                            fontSize="medium"
                            onClick={(e) => handleclearDoc(e, index)}
                          />
                        </span>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      {index === 0 ? (
                        <CustomButton
                          size="small"
                          color="primary"
                          variant="outlined"
                          onClick={handleOnClick}
                          className="invoiceErrbutn"
                        >
                          Add Document
                        </CustomButton>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={3}>
                      <FormControl variant="standard" style={{ width: "100%" }}>
                        <label>
                          <Input
                            accept="*"
                            id={`anyDocs${index}`}
                            onChange={(e) => handlechangeDoc(e, index)}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      {index === 0 ? (
                        <CustomButton
                          size="small"
                          color="primary"
                          variant="outlined"
                          onClick={handleOnClick}
                          className="invoiceErrbutn"
                          style={{ marginTop: "10px " }}
                        >
                          Add Document
                        </CustomButton>
                      ) : (
                        <CustomButton
                          className="invoiceErrbutn"
                          color="error"
                          variant="outlined"
                          size="small"
                          onClick={(e) => handleRemove(e, index)}
                          style={{ marginTop: "10px " }}
                        >
                          Remove
                        </CustomButton>
                      )}
                    </Grid>
                  </>
                )}
              </>
            </Grid>
          </>
        ))}
      </Container>
    </CardContent>
  );

  const additional_info = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>Additional information</VendorCardTitle>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={6} md={9}>
            <VRSubTitle>
              Areas of business interest. Select all that apply and wait for the
              HSN/SAC code to appear below
            </VRSubTitle>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <VRSubTitle style={{ textAlign: "right" }}>
              <a
                rel="noopener noreferrer"
                href={`${client?.domain_url}/api/hsn_codes`}
                style={{
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  color: "#4059e5",
                }}
                target="_blank"
              >
                Download Codesheet
              </a>
            </VRSubTitle>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item md={3} xs={12}>
            <AdditionalDetailsCard>
              <CardContent style={{ overflow: "auto", height: "272px" }}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  // style={{ marginTop: "36px" }}
                >
                  <Grid
                    style={checkedType === "2" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="2"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Goods"
                      style={{
                        textAlign: "-23px",
                      }}
                      onChange={(e) => handleadditionalChange(e, "2")}
                      className="goods"
                    />

                    {checkedType === "2" ? (
                      <ArrowRightIcon
                        style={{
                          textAlign: "center",
                          float: "right",
                          marginTop: "7px",
                          marginLeft: "-32px",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    style={checkedType === "1" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="1"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Services"
                      /*  style={{ textAlign: "-25px" }} */
                      onChange={(e) => handleadditionalChange(e, "1")}
                      className="goods"
                    />
                    <span
                      style={{
                        textAlign: "center",
                        float: "right",
                        marginTop: "7px",
                        marginLeft: "-32px",
                      }}
                    >
                      {checkedType === "1" ? <ArrowRightIcon /> : ""}
                    </span>
                  </Grid>
                  <Grid
                    style={checkedType === "3" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="3"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Item"
                      /*  style={{ textAlign: "-25px" }} */
                      onChange={(e) => handleadditionalChange(e, "3")}
                      className="goods"
                    />
                    <span
                      style={{
                        textAlign: "center",
                        float: "right",
                        marginTop: "7px",
                        marginLeft: "-32px",
                      }}
                    >
                      {checkedType === "3" ? <ArrowRightIcon /> : ""}
                    </span>
                  </Grid>
                </RadioGroup>
              </CardContent>
            </AdditionalDetailsCard>
          </Grid>
          {isLoading ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : code_filtered ? (
            <Grid item md={3} xs={12} style={{ display: catdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => handleSearchChange(e)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by description"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {code_filtered.length ? (
                      code_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            subCategory === `${item.category}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.categortDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={item.categortDescription}
                              value={item.category}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlecategoryChange(e, `${item.category}`)
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingsub ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : sub_filtered ? (
            <Grid item md={3} xs={12} style={{ display: subcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchsub(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {sub_filtered.length ? (
                      sub_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            itemcodes === `${item.subCategory}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.subCategoryDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={
                                item.subCategory +
                                " - " +
                                item.subCategoryDescription
                              }
                              value={item.subCategory}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlesubcategoryChange(
                                  e,
                                  `${item.subCategory}`,
                                )
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingitem ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : item_filtered ? (
            <Grid item md={3} xs={12} style={{ display: itemcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchitem(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  {item_filtered.length ? (
                    item_filtered.map((item, index) => (
                      <FormGroup
                        key={item.id}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                      >
                        <Grid key={item.id}>
                          <Tooltip
                            title={item.itemDescription}
                            placement="bottom"
                          >
                            <CustomFormControl
                              multiple
                              key={item.id}
                              style={{ fontSize: "12px" }}
                              value={item.item}
                              control={
                                <Checkbox
                                  sx={{
                                    color: "lightgray",
                                    "&.Mui-checked": {
                                      color: "#4059e5",
                                    },
                                  }}
                                  checked={personName.includes(`${item.item}`)}
                                />
                              }
                              label={item.item + " - " + item.itemDescription}
                              className="itemName"
                              onChange={(e) =>
                                handleCheckChange(e, `${item.item}`)
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </FormGroup>
                    ))
                  ) : (
                    <VendorCardLabel>
                      <br />
                      <InfoIcon
                        sx={{
                          fill: "grey",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                      {"There are no sub categeories to display"}
                    </VendorCardLabel>
                  )}
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}
          {isLoadingMasteritem ? (
            <Grid item md={9} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : master_item_filtered ? (
            <Grid item md={9} xs={12} style={{ display: mastercatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchMasteritem(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  {master_item_filtered.length ? (
                    master_item_filtered.map((item, index) => (
                      <FormGroup
                        key={item.id}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                      >
                        <Grid key={item.id}>
                          <Tooltip
                            title={item?.MaterialCode}
                            placement="bottom"
                          >
                            <CustomFormControl
                              multiple
                              key={item.id}
                              style={{ fontSize: "12px" }}
                              value={item["MaterialCode"]}
                              control={
                                <Checkbox
                                  sx={{
                                    color: "lightgray",
                                    "&.Mui-checked": {
                                      color: "#4059e5",
                                    },
                                  }}
                                  checked={personName.includes(
                                    `${item.MaterialCode}`,
                                  )}
                                />
                              }
                              label={
                                item["MaterialCode"] +
                                " - " +
                                item["Description"]
                              }
                              className="itemName"
                              onChange={(e) =>
                                handleCheckChange(e, `${item["MaterialCode"]}`)
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </FormGroup>
                    ))
                  ) : (
                    <VendorCardLabel>
                      <br />
                      <InfoIcon
                        sx={{
                          fill: "grey",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                      {"There are no sub categeories to display"}
                    </VendorCardLabel>
                  )}
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        <br />
        <VendorCardTitle style={{ paddingBottom: "0px" }}>
          Selected HSN/SAC Codes
        </VendorCardTitle>
        <FormControl>
          <Stack direction="row" spacing={4}>
            <Grid item xs={2}>
              <VendorCardBlankTitle
                style={{ marginTop: "0", marginBottom: "10px" }}
              >
                {userinfo.codes.length ? "" : "No codes selected."}
              </VendorCardBlankTitle>

              {userinfo.codes.map((item, index) =>
                item !== "null" ? (
                  <Chip
                    key={index}
                    style={{
                      color: "#4945FF",
                      margin: "0 5px 10px 0 ",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={item}
                    value={item}
                    name="chips"
                    onDelete={handleDelete(item)}
                    deleteIcon={
                      <Clear sx={{ height: "18px", width: "18px" }} />
                    }
                  />
                ) : (
                  ""
                ),
              )}
            </Grid>
          </Stack>
        </FormControl>
        <Grid>
          <VendorCardLabel>Additional business areas</VendorCardLabel>
          <TextField
            sx={{
              input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" },
            }}
            id="standard-basic"
            placeholder="Enter interest areas"
            variant="standard"
            style={{ width: "100%" }}
            name="business_interest_areas"
            {...register("business_interest_areas", {
              required: false,
            })}
          />
        </Grid>
        <br />
        {domestic === true ? (
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                onChange={handleChange}
                name="pan_declaration"
              />
            }
            label={
              <CheckBoxLabel>
                I confirm that the PAN I entered above should be used for all
                TDS deductions made for our company payments
              </CheckBoxLabel>
            }
          />
        ) : (
          ""
        )}
      </Container>
    </CardContent>
  );

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep}>
          <div className="stepsDiv">
            {steps.map((label, index) => {
              const stepProps = {};

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }

              // determine status based on activeStep
              const isCurrent = index === activeStep;
              const isCompleted = index < activeStep;
              let statusClass;
              if (isCompleted) {
                // completed steps use green style
                statusClass = "fstone_1";
              } else if (isCurrent) {
                // current step uses orange
                statusClass = "fstone";
              } else {
                statusClass = "secone";
              }

              return (
                <div
                  key={index}
                  className={`stepcolm ${statusClass} ${
                    isCurrent ? "activeStep" : ""
                  }`}
                  style={{ zIndex: steps.length - index }}
                >
                  <div>
                    {index < activeStep ? (
                      <CheckCircleIcon className="checkedCircle" />
                    ) : (
                      <span>{`${index + 1}. `}</span>
                    )}
                    {label}
                  </div>
                </div>
              );
            })}
          </div>
        </Stepper>

        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
            <br />
            {activeStep === 0 ? (
              <form
                onSubmit={handleSubmitData(createUserFn)}
                autoComplete="off"
              >
                <StyledCard>{vendor_information}</StyledCard>
              </form>
            ) : activeStep === 1 ? (
              <>
                <form
                  onSubmit={handleSubmit(handleNext)}
                  encType="multipart/form-data"
                >
                  <StyledCard>{card}</StyledCard>

                  <StyledCard>{statutory_information}</StyledCard>

                  {domestic && <StyledCard>{msme_information}</StyledCard>}

                  <StyledCard>{documents}</StyledCard>

                  <StyledCard>{additional_info}</StyledCard>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Back
                    </Button>

                    <Box sx={{ flex: "1 1 auto" }} />
                    <LoadingButton
                      sx={{
                        textTransform: "none",
                        background: "var(--button-color)",
                        width: "200px",
                        height: "40px",
                      }}
                      color="success"
                      variant="contained"
                      disabled={
                        !domestic
                          ? false
                          : !checkedPan ||
                            (mSME === "Applicable" && !checkedMSME)
                      }
                      type="submit"
                      loading={loading}
                      loadingPosition="start"
                    >
                      Save &amp; Next
                    </LoadingButton>
                  </Box>
                </form>
              </>
            ) : activeStep === 2 ? (
              <>
                <BankReg
                  activeStep={activeStep}
                  skipped={skipped}
                  isStepSkipped={isStepSkipped}
                  setActiveStep={setActiveStep}
                  setSkipped={setSkipped}
                  handleBack={handleBack}
                  checkedPan={checkedPan}
                  steps={steps}
                  registrationtype={vendorData.registration_type}
                  createdUser={createdUser}
                  clientId={client?.id}
                  is_domestic={domestic}
                  isLocationLocked={isLocationLocked}
                />
              </>
            ) : (
              <div>
                <CardContent>
                  <Container fixed>
                    <Grid>
                      <BankDetailsManager
                        activeStep={activeStep}
                        handleBack={handleBack}
                        is_domestic={domestic}
                        company_id={userData.buyer_company_id}
                        vendor_id={vendor_id}
                        user_id={createdUser?.id}
                        setSkipped={setSkipped}
                        setActiveStep={setActiveStep}
                        isStepSkipped={isStepSkipped}
                        skipped={skipped}
                        isLocked={isLocked}
                      />
                    </Grid>
                  </Container>
                </CardContent>
              </div>
            )}
          </React.Fragment>
        )}
      </Box>
    </>
  );
}

export const StyledCard = materialStyles(Card)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorDisabledFields = styled.div`
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #212134;
`;

export const VendorLabelHolder = styled.div`
  text-align: left;
`;

export const StyledOutlineButton = materialStyles(Button)`
  border: 1px solid var(--button-color);
  color: black;
  height: 40px;
  padding: 8px 30px;
`;

export const StyledFilledButton = materialStyles(Button)`
  background: #1CB697;
  color: #fff;
  height: 40px;
  padding: 8px 30px;
`;

export const AdditionalDetailsCard = materialStyles(Card)`
border: 1px solid #D9D8FF;
background: #F7F9FC;
box-shadow: none;
`;

export const VRSubTitle = styled.div`
  margin-top: -15px;
  margin-bottom: 20px;
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  /* Neutral/600 */

  color: #666687;
`;

export const DocumentLabels = styled.div`
  //styleName: 14/Medium;
  font-family: var(--font-family-med);
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
`;

export const CheckBoxLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Neutral/900 */

  color: #212134;
`;

export const StyledStep = materialStyles(Step)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const CustomButton = materialStyles(Button)`
 ::hover{
   background-color: #1cb;
   font-size: 16.5px;
   transition: all 0.3ms ease-in;
 }
`;

export const SelectSpan = styled.span`
  font-family: var(--font-family-reg);
  font-size: 14px;
  color: "black";
`;

export const StepsSpan = styled.span`
  font-family: var(--font-family-reg);
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  padding-right: 10px;
  color: #4a4a6a;
`;

export const CustomFormControl = materialStyles(FormControlLabel)`
.css-ahj2mt-MuiTypography-root {
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;


}
`;

export const CustomFormSelection = materialStyles(FormControlLabel)`
.css-ahj2mt-MuiTypography-root {
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}
`;
